import { all, takeLatest, takeEvery } from 'redux-saga/effects';

import { channelConstants } from '../actions/constants/channelConstants';
import { readingPlanConstants } from '../actions/constants/readingPlanConstants';
import { languageConstants } from '../actions/constants/languageConstants';
import { bibleConstants } from '../actions/constants/bibleConstants';
import { readingConstants } from '../actions/constants/readingConstants';
import { episodeConstants } from '../actions/constants/episodeConstants';
import { userConstants } from '../actions/constants/userConstants';
import { loginConstants } from '../actions/constants/loginConstants';
import { messageBoardConstants } from '../actions/constants/messageBoardConstants';
import { orderConstants } from '../actions/constants/orderConstants';
import { donationConstants } from '../actions/constants/donationConstants';

import { channelSaga } from './channelSaga';
import { readingPlanSaga } from './readingPlanSaga';
import { languageSaga } from './languageSaga';
import { bibleSaga } from './bibleSaga';
import { readingSaga } from './readingSaga';
import { episodeSaga } from './episodeSaga';
import { userSaga } from './userSaga';
import { loginSaga } from './loginSaga';
import { messageBoardSaga } from './messageBoardSaga';
import { orderSaga } from './orderSaga';
import { donationSaga } from './donationSaga';
import { azureConstants } from '../actions/constants/azureConstants';
import { azureSaga } from './azureSaga';
import { videoHotlineConstants } from '../actions/constants/videoHotlineConstants';
import { videoHotlineSaga } from './videoHotlineSaga';
import { testimonialConstants } from '../actions/constants/testimonialConstant';
import { testimonialSaga } from './testimonialSaga';
import { promiseLandConstants } from '../actions/constants/promiseLandConstant';
import { promiseLandSaga } from './promiseLandSaga';
import { settingConstants } from '../actions/constants/settingConstant';
import { settingSaga } from './settingSaga';
import { dabFilmsConstants } from '../actions/constants/dabFilmsConstant';
import { dabFilmsSaga } from './dabFilmsSaga';
import { musicsConstants } from '../actions/constants/musicsConstant';
import { musicsSaga } from './musicsSaga';
import { prayerAndTalksConstants } from '../actions/constants/prayerAndTalksConstant';
import { prayerAndTalksSaga } from './prayerAndTalksSaga';
import { musicPlatformConstants } from '../actions/constants/musicPlatformConstant';
import { musicPlatformSaga } from './musicPlatformSaga';
import { manageCategorySaga } from './manageCategorySaga';
import { manageCatgoryConstants } from '../actions/constants/manageCategoryConstants';
import { videoHotlineCatgoryConstants } from '../actions/constants/videoHotlineCategoryConstants';
import { videoHotlineCategorySaga } from './videoHotlineCategorySaga';
import { resourceConstants } from '../actions/constants/resourceConstant';
import { resourceSaga } from './resourceSaga';
import { releaseNotificationConstants } from '../actions/constants/releaseNotificationConstant';
import { releaseNotificationSaga } from './releaseNotificationSaga';
import { ratingConstants } from '../actions/constants/ratingConstant';
import { ratingSaga } from './ratingSaga';

export default function* rootSaga() {
	yield all([
		//login
		takeLatest(loginConstants.LoginGetDetailRequest, loginSaga.loginGetDetail),
		takeLatest(loginConstants.LogoutGetDetailRequest, loginSaga.logoutGetDetail),
		takeLatest(loginConstants.FrontAppCheckTokenRequest, loginSaga.frontAppCheckToken),
		takeLatest(loginConstants.GetUserByRefreshTokenRequest, loginSaga.getUserByRefreshToken),

		//Forgot Password
		takeLatest(loginConstants.ForgotPasswordCheckTokenRequest, loginSaga.forgotPasswordCheckToken),
		takeLatest(loginConstants.ForgotPasswordChangeRequest, loginSaga.forgotPasswordReset),
		takeLatest(loginConstants.ForgotPasswordRequest, loginSaga.forgotPasswordRequest),

		//channel
		takeLatest(channelConstants.ChannelSaveRequest, channelSaga.channelSave),
		takeLatest(channelConstants.ChannelGetByfilterRequest, channelSaga.channelGetByfilter),
		takeLatest(channelConstants.ChannelGetAllRequest, channelSaga.channelGetAll),
		takeLatest(channelConstants.ChannelDeleteRequest, channelSaga.channelDelete),
		takeLatest(channelConstants.ChannelDetailRequest, channelSaga.channelGetDetail),
		takeLatest(channelConstants.ChannelFaviruteRequest, channelSaga.channelGetFavourite),
		takeLatest(channelConstants.ChannelnonFaviruteRequest, channelSaga.channelGetNonFavourite),

		//Reading Plan
		takeLatest(readingPlanConstants.ReadingPlanDetailRequest, readingPlanSaga.readingPlanGetDetail),
		takeLatest(readingPlanConstants.ReadingPlanGetByFilterRequest, readingPlanSaga.readingPlanGetByFilter),
		takeLatest(readingPlanConstants.ReadingPlanSaveRequest, readingPlanSaga.readingPlanSave),
		takeLatest(readingPlanConstants.ReadingPlanDeleteRequest, readingPlanSaga.readingPlanDelete),
		takeLatest(readingPlanConstants.ReadingPlanDaySaveRequest, readingPlanSaga.readingPlanDaySave),
		takeLatest(readingPlanConstants.ReadingPlanCopyRequest, readingPlanSaga.readingPlanCopy),
		takeLatest(readingPlanConstants.ReadingPlanDayDeleteRequest, readingPlanSaga.readingPlanDayDelete),

		//Reading
		takeLatest(readingConstants.ReadingGetDetailRequest, readingSaga.readingGetDetail),
		takeLatest(readingConstants.ReadingGetByFilterRequest, readingSaga.readingGetByFilter),
		takeLatest(readingConstants.ReadingSaveRequest, readingSaga.readingSave),
		takeLatest(readingConstants.ReadingDeleteRequest, readingSaga.readingDelete),
		takeLatest(readingConstants.ReadingTextUpdateRequest, readingSaga.readingTextUpdate),
		takeLatest(readingConstants.ReadingTitleGetRequest, readingSaga.readingTitleGetExcludeByBible),

		//Language
		takeLatest(languageConstants.LanguageGetByFilterRequest, languageSaga.languageGetByFilter),
		takeLatest(languageConstants.LanguageDetailRequest, languageSaga.languageGetDetail),
		takeLatest(languageConstants.LanguageSaveRequest, languageSaga.languageSave),
		takeLatest(languageConstants.LanguageUpdateRequest, languageSaga.languageUpdate),
		takeLatest(languageConstants.LanguageDeleteRequest, languageSaga.languageDelete),

		//Bibles
		takeLatest(bibleConstants.BibleSaveRequest, bibleSaga.bibleSave),
		takeLatest(bibleConstants.BibleGetByFilterRequest, bibleSaga.bibleGetByFilter),
		takeLatest(bibleConstants.BibleDeleteRequest, bibleSaga.bibleDelete),
		takeLatest(bibleConstants.BibleGetDetailRequest, bibleSaga.bibleGetDetail),
		takeLatest(bibleConstants.BibleGetAllRequest, bibleSaga.bibleGetAll),
		takeLatest(bibleConstants.BibleTranslationSearchRequest, bibleSaga.bibleTranslationSearch),

		//episode
		takeLatest(episodeConstants.EpisodeSaveRequest, episodeSaga.episodeSave),
		takeLatest(episodeConstants.EpisodeGetByFilterRequest, episodeSaga.episodeGetByFilter),
		takeLatest(episodeConstants.EpisodeGetDropdownRequest, episodeSaga.episodeGetDropdownList),
		takeLatest(episodeConstants.EpisodeDeleteRequest, episodeSaga.episodeDelete),
		takeLatest(episodeConstants.EpisodeGetDetailRequest, episodeSaga.episodeGetDetail),
		takeLatest(episodeConstants.EpisodeGetUserCountRequest, episodeSaga.episodeGetUserCountByYear),
		takeLatest(episodeConstants.EpisodeGetReadingRequest, episodeSaga.episodeGetReading),
		takeLatest(episodeConstants.EpisodeGetReadingIdRequest, episodeSaga.episodeGetReadingIdByTitle),
		takeLatest(episodeConstants.EpisodeGetUserEngagementRequest, episodeSaga.episodeGetUserEngagement),
		takeLatest(episodeConstants.EpisodeGetMinDateRequest, episodeSaga.episodeGetMinDate),
		takeLatest(episodeConstants.EpisodeValidateFeedRequest, episodeSaga.episodeGetFeed),
		takeLatest(episodeConstants.EpisodeUserMetricRequest, episodeSaga.episodeGetUserMetric),
		takeEvery(episodeConstants.EpisodeUpdateEngagementRequest, episodeSaga.episodeUpdateEngagement),

		//Roles & User
		takeLatest(userConstants.UserRoleGetByFilterRequest, userSaga.userRoleGetByFilter),
		takeLatest(userConstants.UserGetByFilterRequest, userSaga.userGetByFilter),
		takeLatest(userConstants.UserSaveRequest, userSaga.userSave),
		takeLatest(userConstants.UserSaveCommunityRequest, userSaga.userSaveCommunity),
		takeLatest(userConstants.UserGetDetailRequest, userSaga.userGetDetail),
		takeLatest(userConstants.UserDeleteRequest, userSaga.userDelete),
		takeLatest(userConstants.UserRoleGetRequest, userSaga.userRoleGet),
		takeLatest(userConstants.UserGetCountByYearRequest, userSaga.userGetCountByYear),
		takeLatest(userConstants.UserGetAddressRequest, userSaga.userGetAddress),
		takeLatest(userConstants.UserGetPaymentRequest, userSaga.userGetPaymentsByFilter),
		takeLatest(userConstants.UserUpdateActiveStatusRequest, userSaga.userUpdateActiveStatus),
		takeLatest(userConstants.UserSaveAddressRequest, userSaga.userSaveAddress),
		takeLatest(userConstants.UserRoleSaveRequest, userSaga.userRoleSave),
		takeLatest(userConstants.userAccountUpdateRequest, userSaga.userAccountUpdate),
		takeLatest(userConstants.userGetShopifyAddressRequest,userSaga.userGetShopifyAddress),

		//Prayer Wall / Message Board
		takeLatest(messageBoardConstants.MessageBoard_GetByFilter_Request, messageBoardSaga.messageBoardGetByFilter),
		takeLatest(messageBoardConstants.MessageBoard_GetDetail_Request, messageBoardSaga.messageBoardGetDetail),
		takeLatest(messageBoardConstants.MessageBoard_Save_Request, messageBoardSaga.messageBoardSave),
		takeLatest(messageBoardConstants.MessageBoard_Delete_Request, messageBoardSaga.messageBoardDelete),
		takeLatest(messageBoardConstants.MessageBoard_GetReport_Request, messageBoardSaga.messageBoardGetReport),
		takeLatest(messageBoardConstants.MessageBoard_GetUserPublicMessage_Request, messageBoardSaga.messageBoardGetPublicMessageByUserId),
		takeLatest(messageBoardConstants.MessageBoard_GetUserChannelMessage_Request, messageBoardSaga.messageBoardGetChannelMessageByUserId),
		takeLatest(messageBoardConstants.MessageBoard_GetTopic_Request, messageBoardSaga.messageBoardGetTopicByFilter),
		takeLatest(messageBoardConstants.MessageBoard_TopicDelete_Request, messageBoardSaga.messageBoardTopicDelete),
		takeLatest(messageBoardConstants.MessageBoard_TopicRestore_Request, messageBoardSaga.messageBoardTopicRestore),
		takeLatest(messageBoardConstants.MessageBoard_GetPostByFilter_Request, messageBoardSaga.messageBoardGetPostByFilter),
		takeLatest(messageBoardConstants.MessageBoard_PostDelete_Request, messageBoardSaga.messageBoardPostDelete),
		takeLatest(messageBoardConstants.MessageBoard_PostRestore_Request, messageBoardSaga.messageBoardPostRestore),
		takeLatest(messageBoardConstants.MessageBoard_GetAlert_Request, messageBoardSaga.messageBoardGetAlert),
		takeLatest(messageBoardConstants.MessageBoard_PostFlag_Request, messageBoardSaga.messageBoardPostFlag),
		takeLatest(messageBoardConstants.MessageBoard_PostAuthorization_Request, messageBoardSaga.messageBoardPostAuthorization),
		takeLatest(messageBoardConstants.MessageBoard_GetReportType_Request, messageBoardSaga.messageBoardGetReportType),
		takeLatest(messageBoardConstants.MessageBoard_GetCountByYear_Request, messageBoardSaga.messageBoardGetCountByYear),

		// OrdersAPI
		takeLatest(orderConstants.OrderGetByFilterRequest, orderSaga.orderGetByFilter),
		takeLatest(orderConstants.OrderRecurringGetByFilterRequest, orderSaga.orderRecurringGetByFilter),

		// DonationsAPI
		takeLatest(donationConstants.DonationGetByFilterRequest, donationSaga.donationGetByFilter),
		takeLatest(donationConstants.DonationRecurringGetByFilterRequest, donationSaga.donationRecurringGetByFilter),

		//Azure
		takeLatest(azureConstants.GetUserUsageMetricsRequest, azureSaga.getUserUsageMetric),

		//videoHotline
		takeLatest(videoHotlineConstants.VideoHotlineGetByfilterRequest, videoHotlineSaga.videoHotlineGetByfilter),
		takeLatest(videoHotlineConstants.VideoHotlineDetailRequest, videoHotlineSaga.videoHotlineGetDetail),
		takeLatest(videoHotlineConstants.GetMessageBoardIDRequest, videoHotlineSaga.getMessageBoardID),
		takeLatest(videoHotlineConstants.VideoHotlineDeleteRequest, videoHotlineSaga.videoHotlineDelete),

		//videoHotlineCategory
		takeLatest(videoHotlineCatgoryConstants.VideoHotlineCategoryGetByfilterRequest, videoHotlineCategorySaga.videoHotlineCategoryGetAllCategory),
		takeLatest(videoHotlineCatgoryConstants.VideoHotlineCategoryUpdateStatusRequest, videoHotlineCategorySaga.videoHotlineCategoryStatusUpdate),
		takeLatest(videoHotlineCatgoryConstants.VideoHotlineCategoryCreateRequest, videoHotlineCategorySaga.videoHotlineCategoryCreate),
		takeLatest(videoHotlineCatgoryConstants.VideoHotlineCategoryUpdateRequest, videoHotlineCategorySaga.videoHotlineCategoryUpdate),
		takeLatest(videoHotlineCatgoryConstants.VideoHotlineCategoryDeleteRequest, videoHotlineCategorySaga.videoHotlineCategoryDelete),
		
		//testimonial
		takeLatest(testimonialConstants.Testimonial_GetByFilter_Request, testimonialSaga.testimonialGetByFilter),
		takeLatest(testimonialConstants.TestimonialDetailRequest, testimonialSaga.testimonialGetDetail),
		takeLatest(testimonialConstants.TestimonialStatusUpdateRequest, testimonialSaga.testimonialStatusUpdate),
		takeLatest(testimonialConstants.TestimonialVideoStatusUpdateRequest, testimonialSaga.testimonialVideoStatusUpdate),
		
		//promiseLand
		takeLatest(promiseLandConstants.PromiseLand_GetByFilter_Request, promiseLandSaga.promiseLandGetByFilter),
		takeLatest(promiseLandConstants.PromiseLandDetailRequest, promiseLandSaga.promiseLandGetDetail),
		takeLatest(promiseLandConstants.PromiseLandGetBooksRequest, promiseLandSaga.promiseLandGetAllBooks),
		takeLatest(promiseLandConstants.PromiseLandSaveRequest, promiseLandSaga.promiseLandSave),
		takeLatest(promiseLandConstants.PromiseLandDeleteRequest, promiseLandSaga.promiseLandDelete),

		//manageCategory
		takeLatest(manageCatgoryConstants.ManageCategoryGetByfilterRequest, manageCategorySaga.manageCategoryGetAllCategory),
		takeLatest(manageCatgoryConstants.ManageCategoryUpdateStatusRequest, manageCategorySaga.manageCategoryStatusUpdate),
		takeLatest(manageCatgoryConstants.ManageCategoryCreateRequest, manageCategorySaga.manageCategoryCreate),
		takeLatest(manageCatgoryConstants.ManageCategoryUpdateRequest, manageCategorySaga.manageCategoryUpdate),
		takeLatest(manageCatgoryConstants.ManageCategoryDeleteRequest, manageCategorySaga.manageCategoryDelete),

		//settings
		takeLatest(settingConstants.Setting_Get_Request, settingSaga.settingsGetList),
		takeLatest(settingConstants.SettingContentUpdateRequest, settingSaga.settingContentUpdate),
		takeLatest(settingConstants.SettingStatusUpdateRequest, settingSaga.settingStatusUpdate),
		takeLatest(settingConstants.GetSettingContentRequest, settingSaga.getSettingContent),

		//dabFilms
		takeLatest(dabFilmsConstants.DABFilmsGetByfilterRequest, dabFilmsSaga.dabFilmsGetByfilter),
		takeLatest(dabFilmsConstants.DABFilmsDeleteRequest, dabFilmsSaga.dabFilmsDelete),
		takeLatest(dabFilmsConstants.DABFilmsDetailRequest, dabFilmsSaga.dabFilmsGetDetail),
		takeLatest(dabFilmsConstants.DABFilmsVideoStatusUpdateRequest, dabFilmsSaga.dabFilmsVideoStatusUpdate),
		takeLatest(dabFilmsConstants.DABFilmsSaveRequest, dabFilmsSaga.dabFilmsSave),
		
		//music
		takeLatest(musicsConstants.MusicsGetByfilterRequest, musicsSaga.musicsGetByfilter),
		takeLatest(musicsConstants.MusicsDeleteRequest, musicsSaga.musicsDelete),
		takeLatest(musicsConstants.MusicsDetailRequest, musicsSaga.musicsGetDetail),
		takeLatest(musicsConstants.MusicsSaveRequest, musicsSaga.musicsSave),
		takeLatest(musicsConstants.MusicsVideoStatusUpdateRequest, musicsSaga.musicsVideoStatusUpdate),

		//music platform
		takeLatest(musicPlatformConstants.MusicPlatformGetByfilterRequest, musicPlatformSaga.musicPlatformGetByfilter),
		takeLatest(musicPlatformConstants.MusicPlatformDeleteRequest, musicPlatformSaga.musicPlatformDelete),
		takeLatest(musicPlatformConstants.MusicPlatformDetailRequest, musicPlatformSaga.musicPlatformGetDetail),
		takeLatest(musicPlatformConstants.MusicPlatformSaveRequest, musicPlatformSaga.musicPlatformSave),

		//prayer and talks
		takeLatest(prayerAndTalksConstants.prayerAndTalksDetailRequest, prayerAndTalksSaga.prayerAndTalksGetDetail),
		takeLatest(prayerAndTalksConstants.prayerAndTalksGetChannelRequest, prayerAndTalksSaga.prayerAndTalksGetAllChannels),
		takeLatest(prayerAndTalksConstants.prayerAndTalksSaveRequest, prayerAndTalksSaga.prayerAndTalksSave),

		//resource
		takeLatest(resourceConstants.Resource_GetByFilter_Request, resourceSaga.resourceGetByFilter),
		takeLatest(resourceConstants.Resource_GetActive_Request, resourceSaga.resourceGetActiveList),
		takeLatest(resourceConstants.ResourceSaveRequest, resourceSaga.resourceSave),
		takeLatest(resourceConstants.ResourceDetailRequest, resourceSaga.resourceGetDetail),
		takeLatest(resourceConstants.ResourceDeleteRequest, resourceSaga.resourceDelete),
		takeLatest(resourceConstants.ResourceStatusUpdateRequest, resourceSaga.resourceUpdateStatus),

		//release notification
		takeLatest(releaseNotificationConstants.ReleaseNotificationSettingGetRequest, releaseNotificationSaga.releaseNotificationGetSetting),
		takeLatest(releaseNotificationConstants.ReleaseNotificationSettingUpdateRequest, releaseNotificationSaga.releaseNotificationUpdateSetting),

		//rating
		takeLatest(ratingConstants.RatingSettingGetRequest, ratingSaga.ratingGetSetting),
		takeLatest(ratingConstants.RatingSettingUpdateRequest, ratingSaga.ratingUpdateSetting),
		takeLatest(ratingConstants.RatingDashboardRequest, ratingSaga.ratingGetDashboard),
		takeLatest(ratingConstants.RatingAppVersionsRequest, ratingSaga.ratingGetAppVersions),
		takeLatest(ratingConstants.RatingDeleteRequest, ratingSaga.ratingDelete),

	]);
}